import type ICartTimerHandlerElements from './ICartTimerHandlerElements';

const find = <E extends Element = Element>(selector: string) => document.querySelector(selector) as E;

export default {
  getAll() {
    return {
      $el: find<HTMLDivElement>('.tn-utility-nav-cart-timer'),
      $countdown: find<HTMLSpanElement>('.tn-utility-nav-cart-timer__time'),
      $utilityNav: find<HTMLDivElement>('.tn-utility-nav'),
    };
  },
} as ICartTimerHandlerElements;
